import Vue from 'vue'
import Router from 'vue-router'
import Main from './layouts/Main'
import store from './store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Main,
      children: [
        {
          path: 'about', 
          name: 'About',
          component: function () { 
            return import('./views/About')
          }
        },
        {
          path: 'auth/login', 
          name: 'Login',
          component: function () { 
            return import('./views/Auth/Login')
          }
        },
        {
          path: 'auth/registration', 
          name: 'Registration',
          component: function () { 
            return import('./views/Auth/Registration')
          }
        },
        {
          path: 'auth/forgot', 
          name: 'Forgot password',
          component: function () { 
            return import('./views/Auth/ForgotPassword')
          }
        }
      ]
    },
    {
      path: '/secure',
      meta: { title: 'About - MyApp' },
      name: 'Secure',
      component: function () { 
        return import('./layouts/Secure')
      },
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'dashboard', 
          name: 'Secure dashboard',
          component: function () { 
            return import('./views/Secure/Dashboard')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings', 
          name: 'Settings',
          component: function () { 
            return import('./views/Secure/Settings')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/webhook', 
          name: 'WebhookDetails',
          component: function () { 
            return import('./views/Secure/Settings/webhook')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/webhook/:id', 
          name: 'WebhookEdit',
          component: function () { 
            return import('./views/Secure/Settings/webhook')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/action', 
          name: 'ActionDetails',
          component: function () { 
            return import('./views/Secure/Settings/action')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/action/:id', 
          name: 'ActionEdit',
          component: function () { 
            return import('./views/Secure/Settings/action')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/group', 
          name: 'GroupDetails',
          component: function () { 
            return import('./views/Secure/Settings/group')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/group/:id', 
          name: 'GroupEdit',
          component: function () { 
            return import('./views/Secure/Settings/group')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/additional-field', 
          name: 'AdditionalFieldDetails',
          component: function () { 
            return import('./views/Secure/Settings/additional_field')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/additional-field/:id', 
          name: 'AdditionalFieldEdit',
          component: function () { 
            return import('./views/Secure/Settings/additional_field')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/api-key', 
          name: 'ApiKeyDetails',
          component: function () { 
            return import('./views/Secure/Settings/apikey')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'settings/api-key/:id', 
          name: 'ApiKeyDetailsEdit',
          component: function () { 
            return import('./views/Secure/Settings/apikey')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'profile/edit', 
          name: 'Edit profile',
          component: function () { 
            return import('./views/Secure/Profile/Edit')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'achievements/list', 
          name: 'AchievementsList',
          component: function () { 
            return import('./views/Secure/Achievements/List')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'achievements/create', 
          name: 'AchievementsCreate',
          component: function () { 
            return import('./views/Secure/Achievements/Create')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'achievements/edit/:id', 
          name: 'AchievementEdit',
          component: function () { 
            return import('./views/Secure/Achievements/Create')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'competitions/list', 
          name: 'CompetitionList',
          component: function () { 
            return import('./views/Secure/Competitions/List')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'competitions/create', 
          name: 'CompetitionCreate',
          component: function () { 
            return import('./views/Secure/Competitions/Create')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'competitions/edit/:id', 
          name: 'CompetitionEdit',
          component: function () { 
            return import('./views/Secure/Competitions/Create')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'members/list', 
          name: 'MembersList',
          component: function () { 
            return import('./views/Secure/Members/List')
          },
          meta: {
            requiresAuth: true
          }    
        },
        {
          path: 'members/edit/:id', 
          name: 'MemberEdit',
          component: function () { 
            return import('./views/Secure/Members/Edit')
          },
          meta: {
            requiresAuth: true
          }    
        }
        
      ]
    }

  ]
})


router.beforeEach((to, from, next) => {

  if(to.matched.some(record => record.meta.requiresAuth)) {    
    if (localStorage.getItem('token') == null) {
      next({
        path: '/auth/login',
        params: { nextUrl: to.fullPath }
      });
    }else{
      
      if(!store.state.configLoaded) {
        return store.dispatch('config')
          .then(_ => {
            store.commit('configLoaded');
            next();
          });
      }
      
      next();
    }

  } else {
    next() 
  }
})


export default router
